import { connect } from 'react-redux';
import ReportModal from '../../components/reports/ReportModal';
import { getFilteredTypes, getUserOptions } from '../../selectors/reports';

import {
  closeEditReportModal,
  timeOptions,
  frequencyOptions,
  hourOptions,
  dayOptions,
  weekOptions,
  selectScheduleReport,
  selectScheduleReportTimeframe,
  selectScheduleReportFrequency,
  selectHour,
  selectDay,
  selectWeek,
  selectUser,
  onChangeRecipients,
  editReport,
} from '../../actions/reports';

const mapStateToProps = (state, ownProps) => ({
  open: state.reports.editModal.open,
  reportIndex: state.reports.editModal.reportIndex,
  timeframeIndex: state.reports.editModal.timeframeIndex,
  frequencyIndex: state.reports.editModal.frequencyIndex,
  hourIndex: state.reports.editModal.hourIndex,
  weekIndex: state.reports.editModal.weekIndex,
  dayIndex: state.reports.editModal.dayIndex,
  recipients: state.reports.editModal.recipients,
  title: 'Schedule Report',
  reportOptions: getFilteredTypes(state),
  timeOptions: timeOptions,
  frequencyOptions: frequencyOptions,
  hourOptions: hourOptions,
  weekOptions: weekOptions,
  dayOptions: dayOptions,
  userOptions: getUserOptions(state),
  userSelectIndex: state.reports.editModal.userSelectIndex,
  timezone: state.account.time_zone,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClose: () => {
    dispatch(closeEditReportModal());
  },
  selectReport: (index, options) => {
    dispatch(selectScheduleReport('editModal', index, options));
  },
  selectTimeframe: index => {
    dispatch(selectScheduleReportTimeframe('editModal', index));
  },
  selectFrequency: index => {
    dispatch(selectScheduleReportFrequency('editModal', index));
  },
  onChangeRecipients: value => {
    dispatch(onChangeRecipients('editModal', value));
  },
  selectHour: index => {
    dispatch(selectHour('editModal', index));
  },
  selectWeek: index => {
    dispatch(selectWeek('editModal', index));
  },
  selectDay: index => {
    dispatch(selectDay('editModal', index));
  },
  onSave: () => {
    dispatch(editReport());
  },
  userSelectHandler: index => {
    dispatch(selectUser('editModal', index));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportModal);
